module.exports = __webpack_public_path__ + "assets/photos/memories/frame-2--03972a1c4896bf5d5a951c4e6d832387.png";